__turbopack_context__.v({
  "accordionSlideOverwrite": "logoLink-module-scss-module__IvJH0G__accordionSlideOverwrite",
  "fadeIn": "logoLink-module-scss-module__IvJH0G__fadeIn",
  "fadeOut": "logoLink-module-scss-module__IvJH0G__fadeOut",
  "logoDark": "logoLink-module-scss-module__IvJH0G__logoDark",
  "scaleIn": "logoLink-module-scss-module__IvJH0G__scaleIn",
  "scaleOut": "logoLink-module-scss-module__IvJH0G__scaleOut",
  "zoomIn": "logoLink-module-scss-module__IvJH0G__zoomIn",
  "zoomOut": "logoLink-module-scss-module__IvJH0G__zoomOut",
});
